export const hp_fp_foundersAndPartnersHeaderMonth = {
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const hp_fp_foundersMonth = {
  1: 3,
  2: 3,
  3: 3,
  4: 3,
  5: 3,
  6: 3,
  7: 3,
  8: 3,
  9: 3,
  10: 3,
  11: 3,
  12: 3,
  13: 3,
  14: 3,
  15: 3,
  16: 3,
  17: 3,
  18: 3,
  19: 3,
  20: 3,
  21: 3,
  22: 3,
  23: 3,
  24: 3,
  25: 3,
  26: 3,
  27: 3,
  28: 3,
  29: 3,
  30: 3,
  31: 3,
  32: 3,
  33: 3,
  34: 3,
  35: 3,
  36: 3,
};

export const hp_fp_advisoryBoardMonth = {
  1: 1,
  2: 1,
  3: 2,
  4: 2,
  5: 3,
  6: 3,
  7: 3,
  8: 3,
  9: 3,
  10: 3,
  11: 3,
  12: 3,
  13: 3,
  14: 3,
  15: 3,
  16: 3,
  17: 3,
  18: 3,
  19: 3,
  20: 3,
  21: 3,
  22: 3,
  23: 3,
  24: 3,
  25: 3,
  26: 3,
  27: 3,
  28: 3,
  29: 3,
  30: 3,
  31: 3,
  32: 3,
  33: 3,
  34: 3,
  35: 3,
  36: 3,
};

export const hp_fp_costPerHeadMonth = {
  1: 4000,
  2: 4000,
  3: 4000,
  4: 4000,
  5: 4000,
  6: 4000,
  7: 4000,
  8: 4000,
  9: 4000,
  10: 4000,
  11: 4000,
  12: 4000,
  13: 4000,
  14: 4000,
  15: 4000,
  16: 4000,
  17: 4000,
  18: 4000,
  19: 4000,
  20: 4000,
  21: 4000,
  22: 4000,
  23: 4000,
  24: 4000,
  25: 4000,
  26: 4000,
  27: 4000,
  28: 4000,
  29: 4000,
  30: 4000,
  31: 4000,
  32: 4000,
  33: 4000,
  34: 4000,
  35: 4000,
  36: 4000,
};

export const hp_fa_FinanceTeamMonth = {
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
  12: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 1,
  28: 1,
  29: 1,
  30: 1,
  31: 1,
  32: 1,
  33: 1,
  34: 1,
  35: 1,
  36: 1,
};

export const hp_fa_hrTeamMonth = {
  1: 0,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
  12: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 1,
  28: 1,
  29: 1,
  30: 1,
  31: 1,
  32: 1,
  33: 1,
  34: 1,
  35: 1,
  36: 1,
};

export const hp_fa_legalTeamMonth = {
  1: 0,
  2: 0,
  3: 0,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
  12: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 1,
  28: 1,
  29: 1,
  30: 1,
  31: 1,
  32: 1,
  33: 1,
  34: 1,
  35: 1,
  36: 1,
};
export const hp_fa_costPerHead = {
  1: 2500,
  2: 2500,
  3: 2500,
  4: 2500,
  5: 2500,
  6: 2500,
  7: 2500,
  8: 2500,
  9: 2500,
  10: 2500,
  11: 2500,
  12: 2500,
  13: 2500,
  14: 2500,
  15: 2500,
  16: 2500,
  17: 2500,
  18: 2500,
  19: 2500,
  20: 2500,
  21: 2500,
  22: 2500,
  23: 2500,
  24: 2500,
  25: 2500,
  26: 2500,
  27: 2500,
  28: 2500,
  29: 2500,
  30: 2500,
  31: 2500,
  32: 2500,
  33: 2500,
  34: 2500,
  35: 2500,
  36: 2500,
};

export const hp_other_freelancersMonth = {
  1: 1,
  2: 2,
  3: 2,
  4: 3,
  5: 3,
  6: 3,
  7: 3,
  8: 3,
  9: 3,
  10: 3,
  11: 3,
  12: 3,
  13: 3,
  14: 3,
  15: 3,
  16: 3,
  17: 3,
  18: 3,
  19: 3,
  20: 3,
  21: 3,
  22: 3,
  23: 3,
  24: 3,
  25: 3,
  26: 3,
  27: 3,
  28: 3,
  29: 3,
  30: 3,
  31: 3,
  32: 3,
  33: 3,
  34: 3,
  35: 3,
  36: 3,
};

export const hp_other_costPerHeadMonth = {
  1: 1500,
  2: 1500,
  3: 1500,
  4: 1500,
  5: 1500,
  6: 1500,
  7: 1500,
  8: 1500,
  9: 1500,
  10: 1500,
  11: 1500,
  12: 1500,
  13: 1500,
  14: 1500,
  15: 1500,
  16: 1500,
  17: 1500,
  18: 1500,
  19: 1500,
  20: 1500,
  21: 1500,
  22: 1500,
  23: 1500,
  24: 1500,
  25: 1500,
  26: 1500,
  27: 1500,
  28: 1500,
  29: 1500,
  30: 1500,
  31: 1500,
  32: 1500,
  33: 1500,
  34: 1500,
  35: 1500,
  36: 1500,
};

export const hp_sm_salesTeamKeyMonth = {
  1: 1,
  2: 1,
  3: 1,
  4: 2,
  5: 2,
  6: 2,
  7: 2,
  8: 2,
  9: 2,
  10: 2,
  11: 2,
  12: 2,
  13: 2,
  14: 2,
  15: 2,
  16: 2,
  17: 2,
  18: 2,
  19: 2,
  20: 2,
  21: 2,
  22: 2,
  23: 2,
  24: 2,
  25: 2,
  26: 2,
  27: 2,
  28: 2,
  29: 2,
  30: 2,
  31: 2,
  32: 2,
  33: 2,
  34: 2,
  35: 2,
  36: 2,
};

export const hp_sm_marketingTeamMonth = {
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 2,
  6: 2,
  7: 2,
  8: 2,
  9: 2,
  10: 2,
  11: 2,
  12: 2,
  13: 2,
  14: 2,
  15: 2,
  16: 2,
  17: 2,
  18: 2,
  19: 2,
  20: 2,
  21: 2,
  22: 2,
  23: 2,
  24: 2,
  25: 2,
  26: 2,
  27: 2,
  28: 2,
  29: 2,
  30: 2,
  31: 2,
  32: 2,
  33: 2,
  34: 2,
  35: 2,
  36: 2,
};

export const hp_sm_userAcquisitionMonth = {
  1: 1,
  2: 1,
  3: 1,
  4: 2,
  5: 2,
  6: 2,
  7: 2,
  8: 2,
  9: 2,
  10: 2,
  11: 2,
  12: 2,
  13: 2,
  14: 2,
  15: 2,
  16: 2,
  17: 2,
  18: 2,
  19: 2,
  20: 2,
  21: 2,
  22: 2,
  23: 2,
  24: 2,
  25: 2,
  26: 2,
  27: 2,
  28: 2,
  29: 2,
  30: 2,
  31: 2,
  32: 2,
  33: 2,
  34: 2,
  35: 2,
  36: 2,
};

export const hp_sm_businessDevelopmentMonths = {
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
  12: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 1,
  28: 1,
  29: 1,
  30: 1,
  31: 1,
  32: 1,
  33: 1,
  34: 1,
  35: 1,
  36: 1,
};

export const hp_sm_crmMonths = {
  1: 0,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
  12: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 1,
  28: 1,
  29: 1,
  30: 1,
  31: 1,
  32: 1,
  33: 1,
  34: 1,
  35: 1,
  36: 1,
};

export const hp_sm_subscriberSupportMonths = {
  1: 0,
  2: 0,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
  12: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 1,
  28: 1,
  29: 1,
  30: 1,
  31: 1,
  32: 1,
  33: 1,
  34: 1,
  35: 1,
  36: 1,
};

export const hp_sm_socialMediaAndContentDesignMonth = {
  1: 2,
  2: 2,
  3: 2,
  4: 2,
  5: 2,
  6: 2,
  7: 2,
  8: 2,
  9: 2,
  10: 2,
  11: 2,
  12: 2,
  13: 2,
  14: 2,
  15: 2,
  16: 2,
  17: 2,
  18: 2,
  19: 2,
  20: 2,
  21: 2,
  22: 2,
  23: 2,
  24: 2,
  25: 2,
  26: 2,
  27: 2,
  28: 2,
  29: 2,
  30: 2,
  31: 2,
  32: 2,
  33: 2,
  34: 2,
  35: 2,
  36: 2,
};

export const hp_sm_costPerHeadMonth = {
  1: 2500,
  2: 2500,
  3: 2500,
  4: 2500,
  5: 2500,
  6: 2500,
  7: 2500,
  8: 2500,
  9: 2500,
  10: 2500,
  11: 2500,
  12: 2500,
  13: 2500,
  14: 2500,
  15: 2500,
  16: 2500,
  17: 2500,
  18: 2500,
  19: 2500,
  20: 2500,
  21: 2500,
  22: 2500,
  23: 2500,
  24: 2500,
  25: 2500,
  26: 2500,
  27: 2500,
  28: 2500,
  29: 2500,
  30: 2500,
  31: 2500,
  32: 2500,
  33: 2500,
  34: 2500,
  35: 2500,
  36: 2500,
};
